<template>
    <NestedTableCard
        :active-fields="columns"
        :fields="columns"
        :name-column="nameColumn"
        :fetch="fetch"
        @click="edit"
    >
        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                @click="add"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>

        <template #header-label>
            {{ $t('Page(InternalOrganizations):Component(Text):page-label') }}
        </template>

        <template #cell-contacts="data">
            {{ data.item.contacts.map(c => c.name).join(', ') }}
        </template>

        <template #cell-validFrom="data">
            {{ data.item.validFrom ? renderDate(data.item.validFrom) : '-' }}
        </template>

        <template #cell-validTo="data">
            {{ data.item.validTo ? renderDate(data.item.validTo) : '-' }}
        </template>
    </NestedTableCard>
</template>

<script>
import {BButton} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import NestedTableCard from "@core/components/common/NestedTableCard";
import {SupplyChain} from "@core/api";
import {DateRenderer} from "@core/mixins";
import Ripple from 'vue-ripple-directive'

export default {
    mixins: [DateRenderer],
    directives: {Ripple},
    components: {
        HamletTable,
        NestedTableCard,
        BButton
    },
    data() {
        return {
            nameColumn: {
                key: 'name',
                label: this.$t('Component(Grid):column-name')
            },
            columns: [
                {
                    key: 'state',
                    label: this.$t('Component(Grid):column-state')
                },
                {
                    key: 'contacts',
                    label: this.$t('Component(Grid):column-contact')
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from')
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to')
                },
            ],
        }
    },
    methods: {
        edit(organization) {
            this.$router.push({
                name: 'administration-internal-edit',
                params: {id: organization.id}
            });
        },
        renderContacts(contacts) {
            if (contacts.length > 2) {
                return contacts.splice(0, 2).map(c => c.name).join(', ');
            }

            return contacts.map(c => c.name).join(', ');
        },
        fetch(config, cb) {
            SupplyChain.getInternalOrganizations([], {}, config.page, config.perPage).then(r => {
                cb(r.data.totalItems, r.data.items);
            });
        },
        add() {
            this.$router.push({
                name: 'administration-organization-add',
                params: {type: 'internal'}
            });
        }
    },
}
</script>
